<ng-container *ngIf="games && games.length > 0">
  <div class="header">
    <div class="title" *ngIf="title">{{ title }}</div>
    <div class="title" *ngIf="!title">Предстоящие матчи {{ court.name }}</div>
    <div class="right">
      <div class="navigation" *ngIf="dataSliderComponent && dataSliderComponent.showArrows">
        <a href="javascript:;" (click)="slideLeft()"><mtg-svg-icon icon="icons-arrow-left"></mtg-svg-icon></a>
        <a href="javascript:;" (click)="slideRight()"><mtg-svg-icon icon="icons-arrow-right"></mtg-svg-icon></a>
      </div>
    </div>
  </div>

  <div class="slider">
    <mtg-spinner *ngIf="!games"></mtg-spinner>
    <mtg-data-slider
      *ngIf="games"
      [arrowVisible]="false"
      (scrolledToEnd)="loadNextPage()"
      #dataSliderComponent
    >
      <mtg-data-slider-item *ngFor="let game of games">
        <mtg-game-card
          [game]="game"
          [showTournament]="true"
        ></mtg-game-card>
      </mtg-data-slider-item>
    </mtg-data-slider>
  </div>
</ng-container>
<div class="loading" *ngIf="!games">
  <mtg-spinner></mtg-spinner>
</div>
